module.exports = __webpack_public_path__ + "img/colorado_favorites.e34ef76f.jpg";